


<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12">
            <v-card :loading="loading">
              <v-card-text class="py-0 pt-5 pb-5">
                <v-row class="align-center">
                  <v-col cols="6">
                    <div class="h3 arFont">
                      {{ arabic ? 'تحديث المنتجات' : 'Update Products' }}
                    </div>
                    <v-autocomplete
                      :label="arabic ? 'اختر المتجر' : 'Choose the Store'"
                      :loading="loading"
                      solo
                      return-object
                      required
                      :class="`specialInput ${language == 'ar' ? 'arFont' : ''}`"
                      :style="language == 'ar' ? 'direction:rtl;' : ''"
                      :items="products"
                      item-text="name"
                      item-value="value"
                      :rules="[() => selectedProduct ? true : 'You must choose at least one']"
                      v-model="selectedProduct"
                      @change="manualProductSelection"
                    />
                  </v-col>
                </v-row>

                <!-- Error Alert -->
                <v-alert
                  v-if="errorAlertVisible"
                  color="red"
                  shaped
                  type="error"
                  dismissible
                  @input="errorAlertVisible = false"
                >
                  <div v-if="alertMessage !== ''">
                    {{ arabic ? 'حدث خطأ أثناء ترحيل الطلب إلى نينجا' : 'An error occurred while relaying the request to Ninja' }}
                  </div>
                </v-alert>

                <!-- Success Alert -->
                <v-alert
                  v-if="successAlertVisible"
                  color="green"
                  shaped
                  type="success"
                  dismissible
                  @input="successAlertVisible = false"
                >
                  <div v-if="alertMessage !== ''">
                    {{ arabic ? 'تمت عملية الترحيل إلى نينجا بنجاح' : 'The migration to Ninja was completed successfully.' }}
                  </div>
                </v-alert>

                <!-- Zid Products Section -->
                <div v-if="selectedProduct && selectedProduct.value === 'zid'" id="zidProducts">
                  <div class="text-center my-3">
                    <v-btn :class="`${arabic ? 'arFont' : 'enFont'}`" color="success" :loading="loading" text small @click="reload">{{ i18n['reload'] }}</v-btn>
                  </div>
                  <!-- Product List Table and Pagination for Zid Products -->
                  <v-pagination v-model="currentPage" :total-visible="4" :length="totalPages" @input="onPageChange" />

                  <v-simple-table v-if="zidProducts && zidProducts.length > 0">
                    <thead>
                      <tr>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'SKU' : 'SKU' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'اسم المنتج' : 'Item Name' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'الوصف' : 'Description' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'صورة المنتج' : 'Item Image' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'الإجراء' : 'Action' }}</td>
                        <th>
                          <v-btn @click="ninjaIsSyncAll('zid')" x-small color="success">Ninja Sync all</v-btn>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(result, index) in zidProducts" :key="index">
                        <td>{{ result.sku }}</td>
                        <td>{{ result.name.ar }} / {{ result.name.en }}</td>
                        <td v-html="getShortDescription(result.short_description)"></td>
                        <td>
                        <div v-if="result.images && result.images.length > 0">
                          <img :src="result.images[0].image.thumbnail" alt="Product Image" width="50" height="50" />
                        </div>
                        <div v-else>
                          <span>No Images</span>
                        </div>
                      </td>
                        <td>
                          <v-btn x-small color="success" @click="ninjaIsSync(result.id, 'zid')">Ninja Sync</v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>


                  <!-- No Products Available Message -->
                  <v-simple-table v-else>
                    <tbody>
                      <tr>
                        <td colspan="4" class="text-center">{{ arabic ? 'لا توجد منتجات متاحة' : 'No products available' }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <v-pagination v-model="currentPage" :total-visible="4" :length="totalPages" @input="onPageChange" />
                </div>

                <!-- Salla Products Section -->
                <div v-if="selectedProduct && selectedProduct.value === 'salla'" id="sallaProducts">
                  <div class="text-center my-3">
                    <v-btn :class="`${arabic ? 'arFont' : 'enFont'}`" color="success" :loading="loading" text small @click="reload">{{ i18n['reload'] }}</v-btn>
                  </div>
                  <!-- Product List Table and Pagination for Salla Products -->
                  <v-pagination
                    v-model="currentPage"
                    :total-visible="4"
                    :length="totalPages || 1"  
                    @input="onPageChange"
                  />


                  <v-simple-table v-if="sallaProducts && sallaProducts.length > 0">
                    <thead>
                      <tr>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'SKU' : 'SKU' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'اسم المنتج' : 'Item Name' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'صورة المنتج' : 'Item Image' }}</td>
                        <td :class="`${arabic ? 'arFont' : 'enFont'}`">{{ arabic ? 'الإجراء' : 'Action' }}</td>
                        <th>
                          <v-btn @click="ninjaIsSyncAll('salla')" x-small color="success">Ninja Sync all</v-btn>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(result, index) in sallaProducts" :key="index">
                        <td>{{ result.sku }}</td>
                        <td>{{ result.name }}</td> 
                                <td>
                          <div v-if="result.images && result.images.length > 0">
                            <img :src="result.images[0].url" alt="Product Image" width="50" /> <!-- Use result.images[0].url -->
                          </div>
                          <div v-else>
                            <span>No Images</span>
                          </div>
                        </td>
                        <td>
                          <v-btn x-small color="success" @click="SallaToninjaIsSync(result.id, 'salla')">Ninja Sync</v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <!-- No Products Available Message -->
                  <v-simple-table v-else>
                    <tbody>
                      <tr>
                        <td colspan="4" class="text-center">{{ arabic ? 'لا توجد منتجات متاحة' : 'No products available' }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <v-pagination
  v-model="currentPage"
  :length="totalPages"
  :total-visible="5"
  @input="onPageChange"
/>



               </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
  return {
    zidProducts: [],
    sallaProducts: [],
    currentPage: 1,
    limit: 10,
    totalPages: 1, // Initialize to at least 1
    loading: false,
    alertMessage: '',
    errorAlertVisible: false,
    successAlertVisible: false,
    products: [
      { name: 'Zid Product', value: 'zid' },
      { name: 'Salla Product', value: 'salla' }
    ],
    selectedProduct: null,
    user: null, // To store user data
   // accountId :null,

  };
},

  methods: {
    manualProductSelection() {
      this.fetchProducts();
    },
    async fetchUser() {
      try {
        this.user = await this.$store.dispatch('getUser');
        console.log('User data fetched:', this.user);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    },


    async fetchProducts() {
      if (!this.user || !this.user.account || !this.user.account.id) {
        console.error('User or account data is missing.');
        return;
      }
      const accountId = this.user.account.id;

      if (this.selectedProduct.value === 'zid') {
        await this.fetchZidProducts(accountId);
      } else if (this.selectedProduct.value === 'salla') {
        await this.fetchSallaProducts(accountId);
      //  this.fetchUser();
      }
    },
    async fetchZidProducts(accountId) {
      this.loading = true;
   //   const accountId = this.user.account.id;

      try {
        const response = await this.$store.dispatch('getResource', {
          resource: `/apps/zid/get-products?account_id=${accountId}&page=${this.currentPage}&limit=${this.limit}`,
        });

        if (response && response.products_data) {
          this.zidProducts = response.products_data.results;
          this.totalPages = Math.ceil(response.products_data.total_products_count / this.limit);
        } else {
          this.zidProducts = [];
          this.totalPages = 1;
        }
      } catch (error) {
        this.zidProducts = [];
        this.totalPages = 1;
      } finally {
        this.loading = false;
      }
    },
    async fetchSallaProducts(accountId) {
  this.loading = true;
  try {
  //  alert(this.user)
    const response = await this.$store.dispatch('getResource', {
     // resource: `/apps/salla/get-products?page=${this.currentPage}&per_page=${this.limit}`, // Fixed to 10
      resource: `/apps/salla/get-products?account_id=${accountId}&page=${this.currentPage}&limit=${this.limit}`,

    });

    if (response && response.success) {
      this.sallaProducts = response.products_data || [];
      this.currentPage = response.current_page || 1;
      this.totalPages = response.total_pages || 1;
    } else {
      this.sallaProducts = [];
      this.totalPages = 1;
    }
  } catch (error) {
    console.error('Error fetching Salla products:', error);
    this.sallaProducts = [];
    this.totalPages = 1;
  } finally {
    this.loading = false;
  }
}
,

async SallaToninjaIsSyncAll(type) {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('getResource', {
          resource: `/apps/${type}/products/import-all?account_id=${accountId}`
        });
        this.loading = false;
        if (response.status === 'success') {
          this.successAlertVisible = true;
          this.errorAlertVisible = false;
          this.alertMessage = response.message;
        } else if (response.status === 'error') {
          this.errorAlertVisible = true;
          this.successAlertVisible = false;
          this.alertMessage = response.message;
        }
        this.fetchProducts();
      } catch (error) {
        this.loading = false;
        this.errorAlertVisible = true;
        this.successAlertVisible = false;
        this.alertMessage = error.message;
        this.fetchProducts();
      }
    },
    async SallaToninjaIsSync(id_product, type) {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('getResource', {
          resource: `/apps/${type}/products/import?account_id=${accountId}&id=${id_product}`,
        });
        this.loading = false;

        if (response.status === 'success') {
          this.successAlertVisible = true;
          this.errorAlertVisible = false;
          this.alertMessage = response.message;
        } else if (response.status === 'error') {
          this.errorAlertVisible = true;
          this.successAlertVisible = false;
          this.alertMessage = response.message;
        }
        this.fetchProducts();
      } catch (error) {
        this.loading = false;
        this.errorAlertVisible = true;
        this.successAlertVisible = false;
        this.alertMessage = error.message;
        this.fetchProducts();
      }
    },
    getShortDescription(shortDescription) {
    if (!shortDescription) {
      return 'No description available';
    }
    return this.arabic ? shortDescription.ar || 'No description available' : shortDescription.en || 'No description available';
  },


    async ninjaIsSyncAll(type) {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('getResource', {
          resource: `/apps/${type}/products/import-all?account_id=${accountId}`
        });
        this.loading = false;
        if (response.status === 'success') {
          this.successAlertVisible = true;
          this.errorAlertVisible = false;
          this.alertMessage = response.message;
        } else if (response.status === 'error') {
          this.errorAlertVisible = true;
          this.successAlertVisible = false;
          this.alertMessage = response.message;
        }
        this.fetchProducts();
      } catch (error) {
        this.loading = false;
        this.errorAlertVisible = true;
        this.successAlertVisible = false;
        this.alertMessage = error.message;
        this.fetchProducts();
      }
    },
    async ninjaIsSync(id_product, type) {
  this.loading = true;
  try {
    console.log(`Request: id_product=${id_product}, type=${type}`); // Log request parameters
    const response = await this.$store.dispatch('getResource', {
      resource: `/apps/${type}/products/import?account_id=${this.user.account.id}&id=${id_product}`,
    });
    console.log('Response:', response); // Log the response

    this.loading = false;

    if (response.status === 'success') {
      this.successAlertVisible = true;
      this.errorAlertVisible = false;
      this.alertMessage = response.message;
    } else if (response.status === 'error') {
      console.error('Error Response:', response); // Log error details
      this.errorAlertVisible = true;
      this.successAlertVisible = false;
      this.alertMessage = response.message;
    }
    this.fetchProducts();
  } catch (error) {
    console.error('Error Occurred:', error); // Log error details
    alert(`Error: ${error.message}`); // Show alert for the error
    this.loading = false;
    this.errorAlertVisible = true;
    this.successAlertVisible = false;
    this.alertMessage = error.message;
    this.fetchProducts();
  }
},



    reload() {
      this.fetchProducts();
    },
    onPageChange(page) {
    this.currentPage = page; // Update currentPage
    this.fetchProducts(); 
    this.fetchSallaProducts(accountId); // Fetch products for the current page
    // Fetch products for the current page
}
,
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language] || {};
    },
    arabic() {
      return this.$store.state.language === 'ar';
    },
    language() {
      return this.$store.state.language; // Assuming language is stored in Vuex state
    },
  },

  async mounted() {
    await this.fetchUser(); // Fetch user data on component mount
    await this.fetchProducts(); // Fetch products after user data is loaded
  },
};
</script>

<style scoped>
.arFont {
  direction: rtl;
  text-align: right;
}

.enFont {
  direction: ltr;
  text-align: left;
}
</style>
 